import React from 'react';
import './styles.scss';
import { AddInternalProcurementType } from 'models/procurement.model';
import IngredientSelct from 'components/form-comps/ingredients-select';
import CurrencyInput from 'components/base/currency-input';

const NewTransferForm = ({
  data,
  index,
  setValue,
  removeItem
}: {
  data: AddInternalProcurementType;
  index: number;
  setValue: (
    index: number,
    field: keyof AddInternalProcurementType,
    value: string | number
  ) => void;
  removeItem: (index: number) => void;
}) => {
  return (
    <div className={`add__procurement pb-4 ${index > 0 ? 'pt-6' : ''} border-b border-[#EDEDEE]`}>
      <div>
        <div className='grid grid-cols-2 gap-6 mb-6 flex-wrap'>
          <div>
            <p className='font-medium mb-2'>Item name</p>
            <IngredientSelct
              value={data?.ingredient_name}
              setValue={(item) => {
                setValue(index, 'ingredient_id', item.id);
                setValue(index, 'ingredient_name', item.name);
              }}
            />
          </div>
          <div className='relative'>
            <CurrencyInput
              label='Quantity'
              placeholder='00'
              value={data.quantity}
              onChange={(e) => setValue(index, 'quantity', Number(e))}
              hasUnit
              hideCurrency
              unitValue=''
            />
          </div>
        </div>
        {index >= 1 && (
          <button
            onClick={() => removeItem(index)}
            className='text-[#E60A2B] mt-2 font-medium text-sm '>
            - Remove Item
          </button>
        )}
      </div>
    </div>
  );
};

export default NewTransferForm;
